<template>
  <tr>
    <td>
      <div>
        <input type="text"
               style="border: 1px solid #ccc; padding: 5px; border-radius: 2px; max-width: 80px"
               v-model:="measurement.value"
               v-bind:style="pet_weight_input_size"
        >
        &nbsp;
        <span class="save-weight-button" @click=createMeasurement>
          <i class="fa fa-check"></i>
        </span>
      </div>
      &nbsp;
    </td>
    <td></td>
    <td><Datetime :value="measurement.measured_at"></Datetime></td>
    <td>
      <div class="dropstart">
        <i class="fas fa-remove"></i>
      </div>
    </td>
  </tr>
</template>

<script>
import Datetime from "@/components/Datetime.vue";
import petMeasurementsService from "@/services/petMeasurements.service";
import showSwal from "@/mixins/showSwal";

export default {
  name: "PetMeasurementCreatingListItem",
  components: {Datetime},
  emits: ["created"],

  props: {
    prev_value: {
      type: String,
    },
    pet_id: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      measurement: {
        pet_id: this.pet_id,
        value: this.prev_value || 0,
        measured_at: new Date(),
      },
    }
  },

  computed: {
    pet_weight_input_size() {
      let len = (this.measurement.value + "").length
      if (!len) {
        len = 2
      }

      len *= 5

      return "width:" + len + "em"
    },
  },

  methods: {
    createMeasurement() {
      petMeasurementsService.
        createWeightMeasurement({
          pet_id: this.measurement.pet_id,
          value: parseFloat(this.measurement.value),
          subject: "weight",
          measured_at: this.measurement.measured_at,
        }).
        then((response) => {
          showSwal.methods.showSwal({
            type: "success",
            message: "Запись успешно добавлена",
          });
          this.$emit("created", response)
        }).
        catch(() => {
          showSwal.methods.showSwal({
            type: "error",
            message: "Что-то пошло не так",
          });
        })
      },
  },
}
</script>

<style scoped>

</style>